// extracted by mini-css-extract-plugin
module.exports = {"remoteVideoGroup":"LiveStreamRemoteVideoGroup_remoteVideoGroup__39Djk","remoteVideo":"LiveStreamRemoteVideoGroup_remoteVideo__286J-"};